
import CommonUtils from "@/common-utils";
import Constants from "@/constants";
import { KeywordVO, MstSearchVO } from "@/views/biz/search/vo/search.vo";
import axios from "axios";
import debounce from "lodash-es/debounce";
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";

@Component
export default class SearchForm extends Vue {
  @Prop({ default: true})
  isSearchInput!: boolean;
  @Prop({ default: () => ({}) })
  placeholder!: KeywordVO;
  keyword = "";

  autoCompleteList = [] as Array<MstSearchVO>;

  autoComplateKeywordfocusIndex = -1;

  refreshEnabled = false;

  @Watch("$route.name")
  onRouteChanged() {
    this.autoCompleteList = [];
    if (this.$route.path.indexOf("search") >= 0) {
      // 검색 결과 화면에선 키워드 초기화 안함
      return;
    }
    this.keyword = "";
    if(this.refreshEnabled) {
      this.refreshEnabled = false;
      this.isPullToRefreshEnabled(true);
    }
  }

  @Watch('keyword')
  onChangeKeyword() {
    this.autoComplateKeywordfocusIndex = -1;
    if(this.keyword === "" && this.refreshEnabled){
      this.refreshEnabled = false;
      this.isPullToRefreshEnabled(true);
    }
  }

  // 키워드 검색 라우터명(검색 탭에 따라 다름)
  get keywordSearchRouterName() {
    let dest = "SearchProducts";
    if (this.$route.name == "SearchUgcs") {
      dest = "SearchUgcs";
    }
    return dest;
  }

  // 최근 검색어
  static getRecentSearchHistory(): Array<MstSearchVO> {
    const recentSearchHistories = CommonUtils.getLocalStorageObject(Constants.SEARCH_HISTORIES) || {};
    return recentSearchHistories.keywords || [];
  }

  // 최근 검색어 추가
  static addRecentSearchHistory(searchHistory: MstSearchVO): Array<MstSearchVO> {
    const recentSearchHistories = this.getRecentSearchHistory();
    const newHistories = [] as Array<MstSearchVO>;
    recentSearchHistories.unshift(searchHistory);

    // 중복 제거(더 빠르게 가능한데 귀찮음)
    recentSearchHistories.forEach((v) => {
      let test = true;
      newHistories.forEach((vv) => {
        if (v.keyword == vv.keyword) {
          test = false;
          return;
        }
      });
      test && newHistories.push(v);
    });
    // 자름
    CommonUtils.putLocalStorageObject(Constants.SEARCH_HISTORIES, { keywords: newHistories.slice(0, 20) });
    return newHistories;
  }
  // 비우기
  static clearSearchHistory(): void {
    localStorage.removeItem(Constants.SEARCH_HISTORIES);
  }

  // 자동완성
  autoComplete = debounce(this.autoComplete2, 300);
  autoComplete2(e: any): void {
    if (!e || !e.target) {
      return;
    }
    const keyword = e.target.value;

    // 엔터키
    if (e.keyCode == 13) {
      this.search({ keyword: keyword } as MstSearchVO);
      return;
    }

    if (!keyword || !keyword.trim() || keyword.trim() == this.$route.params.keyword) {
      this.autoCompleteList = [];
      return;
    }
    axios.get(`/search/${keyword}`).then((r) => {
      this.autoCompleteList = r.data;
    });

    // 검색시 PullToRefresh 막기
    if(!this.refreshEnabled) {
      this.refreshEnabled = true;
      this.isPullToRefreshEnabled(false);
    }
  }

  // 검색 ㄱㄱ
  search(item?: MstSearchVO) {
    if (!item && !this.keyword) {
      if (!this.placeholder.keyword) {
        alert(this.$t("search.a0001")); // 검색어를 입력해주세요
      } else {
        this.$router.push(this.placeholder.link);
      }
      return;
    }
    // 자동완성창 닫고
    this.autoCompleteList = [];

    // 키워드 검색
    if (!item) {
      item = {} as MstSearchVO;
      item.keyword = this.keyword;
    }

    SearchForm.addRecentSearchHistory(item);
    this.$emit("update");

    switch (item.typeCd) {
      case "01": // 카테고리
        this.$router.push({ name: "CategoryProducts", params: { cateCd: item.targetCd } });
        break;
      case "02": // 브랜드
        this.$router.push({ name: "BrandProducts", params: { brandCd: item.targetCd } });
        break;
      case "03": // 상품
        this.$router.push({ name: "Product", params: { productCd: item.targetCd } });
        break;
      default:
        if (item.keyword && item.keyword.trim() == this.$route.params.keyword) {
          break;
        }
        this.$store.commit("touchKeepAlive");
        this.$router.push({ name: this.keywordSearchRouterName, params: { keyword: item.keyword } });
        break;
    }
    
    // 검색시 PullToRefresh 막기
    if(!this.refreshEnabled) {
      this.refreshEnabled = true;
      this.isPullToRefreshEnabled(false);
    }
  }

  // 검색창 초기화
  resetSearchBar() {
    this.keyword = "";
    this.autoCompleteList = [];
    (this.$refs.keyword as HTMLInputElement).focus();
  }
  // 뒤로가기 버튼
  onBackbutton() {
    // 자동 완성 켜져 있으면
    if (this.autoCompleteList.length) {
      this.resetSearchBar();
      return;
    }
    this.$router.go(-1);
  }

  created() {
    this.keyword = this.$route.params.keyword;
    // 로그인memCd(로그용)
    this.keyword &&
      axios.get("/login/mc").then((r) => {
        CommonUtils.log("Search", r.data, { kw: this.keyword });
      });
  }

  // PC 자동완성 키보드 제어
  keyDown(isUp: boolean) {
    if(this.$isMobile == true) {
      return;
    }

    if(!this.autoCompleteList.length) {
      return;
    }

    if(isUp == true && this.autoComplateKeywordfocusIndex == 0) {
      return;
    }

    if(isUp == false && (this.autoCompleteList.length -1) == this.autoComplateKeywordfocusIndex) {
      return;
    }

    if(isUp == true) {
      this.autoComplateKeywordfocusIndex --;
      return;
    } 

    this.autoComplateKeywordfocusIndex ++;
  }

  // PC 자동완성 키보드 제어
  keyEnter() {
    if(this.$isMobile == true) {
      return;
    }

    // 자동완성 목록에서 선택받지 못했다면
    if(this.autoComplateKeywordfocusIndex == -1) {
      return;
    }

    this.keyword = this.autoCompleteList[this.autoComplateKeywordfocusIndex].keyword;
  }
  
  isPullToRefreshEnabled = (type: boolean) => {
    if(this.$isMobile) {
      if(window["webViewBridge"]) {
        const {send} = window["webViewBridge"];
        send("refresh", {type});
      }
    }
  }
}
